/**
 * Copyright 2022-present terrestris GmbH & Co. KG
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 * list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 * IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 * INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING,
 * BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
 * LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE
 * OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED
 * OF THE POSSIBILITY OF SUCH DAMAGE.
 */
import React from 'react';

import {
  faAngleDoubleLeft
} from '@fortawesome/free-solid-svg-icons';
import {
  FontAwesomeIcon
} from '@fortawesome/react-fontawesome';

import SimpleButton, {
  SimpleButtonProps
} from '@terrestris/react-geo/dist/Button/SimpleButton/SimpleButton';

import {
  useAppDispatch
} from '../../hooks/useAppDispatch';
import {
  toggleVisibility
} from '../../store/drawer';

import './ToggleDrawerButton.less';

export const ToggleDrawerButton: React.FC<Partial<SimpleButtonProps>> = (
  props
): React.JSX.Element => {
  const dispatch = useAppDispatch();

  const toggleDrawer = () => {
    dispatch(toggleVisibility());
  };

  return (
    <SimpleButton
      tooltip='Themen und Objektinformationen anzeigen'
      tooltipProps={{
        mouseEnterDelay: .1,
        placement: 'right'
      }}
      size='large'
      className='toggle-drawer-button'
      onClick={toggleDrawer}
      icon={
        <FontAwesomeIcon
          icon={faAngleDoubleLeft}
        />
      }
    >
      Themen
    </SimpleButton>
  );
};

export default ToggleDrawerButton;
